import type { SearchDocument } from '@/entities/Document';
import { createDocumentRevisionsStore } from './createDocumentRevisionsStore';

export const store = createDocumentRevisionsStore<SearchDocument>('documentRevisions');
